<template>
    <vx-expandable-card>
        <template v-slot:content>
            <div class="vx-grid vx-grid-cols-12">
                <div class="vx-col-span-12 vx-mb-4 lg:vx-col-span-6 lg:vx-pr-4 lg:vx-mb-0">
                    <vx-badge color="violet" size="sm" class="!vx-px-2">
                        Optional
                        <font-awesome-icon :icon="faPencilSlash"></font-awesome-icon>
                    </vx-badge>
                    <h3 class="vx-mt-2 vx-text-xl vx-text-slate-700 vx-font-extrabold">Starter Template</h3>
                    <p class="vx-text-sm">
                        Download a template to get going. Checkout out more advanced examples in our
                        <a
                            href="https://support.voxie.com/hc/en-us/articles/17981465256333"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="!vx-no-underline vx-text-sky-500"
                            >documentation</a
                        >.
                    </p>
                </div>
                <div class="vx-col-span-12 lg:vx-col-span-6">
                    <div class="vx-bg-white vx-shadow vx-p-4 vx-rounded-[8px]">
                        <h3 class="vx-text-slate-500 vx-text-xs vx-mb-2 vx-font-sans vx-font-normal">
                            Simple template
                        </h3>
                        <table class="vx-mb-4 vx-text-xs vx-border-solid vx-border vx-border-gray-300 vx-text-black">
                            <thead>
                                <tr>
                                    <th class="vx-p-1 vx-border vx-border-solid vx-font-normal vx-border-gray-300">
                                        first_name
                                    </th>
                                    <th class="vx-p-1 vx-border vx-border-solid vx-font-normal vx-border-gray-300">
                                        last_name
                                    </th>
                                    <th class="vx-p-1 vx-border vx-border-solid vx-font-normal vx-border-gray-300">
                                        phone
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="vx-p-1 vx-border vx-border-solid vx-font-normal vx-border-gray-300">
                                        Jane
                                    </td>
                                    <td class="vx-p-1 vx-border vx-border-solid vx-font-normal vx-border-gray-300">
                                        Smith
                                    </td>
                                    <td class="vx-p-1 vx-border vx-border-solid vx-font-normal vx-border-gray-300">
                                        15554443333
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <vx-button block download :href="onCorporate() ? csvUrl : groupCsvUrl">
                            Download CSV
                            <font-awesome-icon :icon="faDownload"></font-awesome-icon>
                        </vx-button>
                    </div>
                </div>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { faDownload, faPencilSlash } from '@fortawesome/pro-solid-svg-icons';
import { VxExpandableCard, VxBadge, VxButton } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import csvUrl from '@csv/contact_csv_upload_template_with_subscriptions.csv';
import groupCsvUrl from '@csv/contact_csv_upload_template_without_subscriptions.csv';
import { useCurrentGroup } from '~/composables/useCurrentGroup';

const { onCorporate } = useCurrentGroup();
</script>
